module.exports = __webpack_public_path__ + "components/blogs-header/static/header--small-5fd93b3bd2ac81e0aa28f910f3d4d7d6.jpg";